import { Shield, Star } from 'lucide-react';

function TrustBadge({ trust }) {
  if (!trust) return null;

  const { avg_rating, total_ratings, is_verified, successful_deliveries } = trust;

  return (
    <div data-testid="trust-badge" className="flex items-center gap-2">
      {is_verified && (
        <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-emerald-500/15 border border-emerald-500/25 text-[9px] font-bold text-emerald-300">
          <Shield className="w-2.5 h-2.5" /> Verified
        </span>
      )}
      {total_ratings > 0 && (
        <span className="inline-flex items-center gap-0.5 text-[10px] text-slate-400">
          <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" />
          <span className="font-semibold text-white">{avg_rating}</span>
          <span>({total_ratings})</span>
        </span>
      )}
      {successful_deliveries > 0 && (
        <span className="text-[9px] text-slate-500">{successful_deliveries} deliveries</span>
      )}
    </div>
  );
}

function StarRating({ rating, onRate, readonly = false, size = 'md' }) {
  const starSize = size === 'sm' ? 'w-4 h-4' : 'w-6 h-6';

  return (
    <div data-testid="star-rating" className="flex gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          data-testid={`star-${star}`}
          onClick={() => !readonly && onRate?.(star)}
          disabled={readonly}
          className={`${readonly ? 'cursor-default' : 'cursor-pointer active:scale-110'} transition-transform`}
        >
          <Star className={`${starSize} ${
            star <= rating
              ? 'text-yellow-400 fill-yellow-400'
              : 'text-slate-600'
          }`} />
        </button>
      ))}
    </div>
  );
}

export { TrustBadge, StarRating };
